export const getBrandShopRouteByLocale = (locale: string): string => {
  // Define a base route mapping for common cases
  const brandShopcommonRoute = '/brand-shop'

  // Map specific routes for certain locales
  const routes: Record<string, string> = {
    'sv-se': '/varumarkesshop-online',
    'fi-fi': '/brandikauppa',
    'pt-pt': '/oficina-marca',
    'nl-nl': '/brandstore',
    'es-es': '/tienda-personalizada',
    'de-de': '/markenshop',
    'fr-fr': '/boutique-personnalisee',
    'it-it': '/hub-marchio',
    'no-no': '/profilering',
    'dk-dk': '/brandingbutikken',
    'da-dk': '/brandingbutikken',
    'ch-de': '/markenshop',
    'ch-fr': '/markenshop',
    'at-at': '/markenshop',
    'de-at': '/markenshop',
    'be-be': '/brandstore',
    'fr-ca': '/fr/boutique-marque',
    'fr-ch': '/fr/boutique-personnalisee',
    'de-ch': '/markenshop',
    'nl-be': '/brandstore',
    'fr-be': '/fr/boutique-personnalisee',
    'it-ch': '/it/hub-marchio',
    'nb-no': '/profilering',
    'es-us': '/es/tienda-personalizada',
  }

  // If the locale exists in the mapping, return the mapped route, else return the common route
  return routes[locale] || brandShopcommonRoute
}

export const getBrandShopRouteByLocaleAndBrandId = (locale: string, brandId: string): string => {
  return getBrandShopRouteByLocale(locale) + `/?brandId=${brandId}`
}

export const getBrandKitRouteByLocale = (locale: string): string => {
  // Define a base route mapping for common cases
  const brandKitcommonRoute = '/brand-kit'

  // Map specific routes for certain locales
  const routes: Record<string, string> = {
    'sv-se': '/varumarkespaket',
    'fi-fi': '/brandipaketti',
    'pt-pt': '/kit-marca',
    'nl-nl': '/brand-identity',
    'es-es': '/kit-marca',
    'de-de': '/markenkit',
    'fr-fr': '/kit-marque',
    'it-it': '/kit-marchio',
    'no-no': '/designpakke-profilering',
    'dk-dk': '/brandingsaet',
    'da-dk': '/brandingsaet',
    'ch-de': '/markenkit',
    'ch-fr': '/kit-marque',
    'at-at': '/markenkit',
    'de-at': '/markenkit',
    'be-be': '/brand-identity',
    'fr-ca': '/fr/materiel-marque',
    'fr-ch': '/fr/kit-marque',
    'de-ch': '/markenkit',
    'nl-be': '/brand-identity',
    'fr-be': '/fr/kit-marque',
    'it-ch': '/it/kit-marchio',
    'nb-no': '/designpakke-profilering',
    'es-us': '/es/kit-marca',
  }

  // If the locale exists in the mapping, return the mapped route, else return the common route
  return routes[locale] || brandKitcommonRoute
}

export const getBrandKitUrlByLocale = (locale: string, brandID?: string): string => {
  const baseRoute = getBrandKitRouteByLocale(locale)
  return brandID ? `${baseRoute}/?brandId=${brandID}` : `${baseRoute}/`
}
